export enum CompanyInfoType {
  DESCRIPTION = 'DESCRIPTION'
}
